import React, { useState } from "react";
import styled from "styled-components";
// import fireIcon from 'images/icon/round_fire_icon-116x116.png'
// import snowIcon from 'images/icon/round_snow_icon-116x116.png'
import uniRunning from "images/character/uni_running-133x144.png";
// import santaRunning from 'images/character/santa-134x136.png'
import goalIcon from "images/icon/goal_icon-82x86.png";
// import christmasIcon from 'images/icon/christmas_home-82x84.png';
// import snowEffect from 'images/lottiefile/snow_effect.json';
// import LottieLoader from 'components/containers/common/LottieLoader';
// import kiteFlying from 'images/character/kite_flying-110x90.png';
// import tileHouse from 'images/icon/tile_house-82x80.png';
import calendarIcon from "images/icon/calendar_icon-46x50.png";

export default function MyAchievementRate({
  userInfo,
  taskCount,
  completeRate,
  handleClickCalendar,
}) {
  const [playAnimation, setPlayAnimation] = useState(false);
  let myAchievementTopText = null;

  if (completeRate === 0) {
    myAchievementTopText = "달릴 준비 되셨나요? 준비이~ 땅!💥";
  } else if (completeRate > 0 && completeRate <= 50) {
    myAchievementTopText = "잘 달리고 있어요! 페이스를 유지해봐요🔥";
  } else if (completeRate > 50 && completeRate < 100 && taskCount !== null) {
    myAchievementTopText = `${
      taskCount["task_count"] - taskCount["result_count"]
    }번만 더하면 목표지점이에요!`;
  } else if (completeRate === 100) {
    myAchievementTopText = "끝까지 달린 당신은 불꽃 열정러🔥";
  }

  return (
    <>
      <MyAchievementRateBlock>
        <AchievementInfoBlock>
          <NickName>{`${userInfo["name"]}님,`}</NickName>
          <AchievementGoalDesc>{myAchievementTopText}</AchievementGoalDesc>
        </AchievementInfoBlock>
        <AchievememntProgressBarBlock>
          <AchievememntProgressBar>
            <RunningIconBlock
              left={completeRate}
              playAnimation={playAnimation}
              onAnimationEnd={() => {
                setPlayAnimation(false);
              }}
            >
              <RunningIcon src={uniRunning} />
            </RunningIconBlock>
            <ProgressbarLine width={completeRate} />
          </AchievememntProgressBar>
          {taskCount ? (
            <TaskCountBlock>
              <CompleteNum>{taskCount["result_count"]}</CompleteNum>/
              <TotalTaskNum>{taskCount["task_count"]}</TotalTaskNum>
            </TaskCountBlock>
          ) : null}
          <GoalIconBlock>
            <GoalIcon src={goalIcon} />
          </GoalIconBlock>
        </AchievememntProgressBarBlock>
        {/* <JumpBtn onClick={handleClickCalendar}>
				<JumpBtnImgBlock>
					<JumpBtnImg src={calendarIcon} alt={'jump btn'}/>
				</JumpBtnImgBlock>
			</JumpBtn> */}
      </MyAchievementRateBlock>
    </>
  );
}

const MyAchievementRateBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: calc(100vw * (165 / 375));
  min-height: calc(100vw * (165 / 375));
  background: #fff;
  border-radius: calc(100vw * (10 / 375));
  box-shadow: 0px 0px 20px rgba(191, 191, 191, 0.5);
  margin-bottom: calc(100vw * (23 / 375));
  padding: calc(100vw * (12 / 375)) calc(100vw * (23 / 375))
    calc(100vw * (23 / 375)) calc(100vw * (21 / 375));
`;

const AchievementInfoBlock = styled.div`
  width: 100%;
  margin-bottom: calc(100vw * (26 / 375));
`;

const NickName = styled.h2`
  font-size: calc(100vw * (20 / 375));
  font-weight: 700;
  line-height: calc(100vw * (31.66 / 375));
`;

const AchievementGoalDesc = styled.p`
  font-size: calc(100vw * (15 / 375));
  font-weight: 500;
  line-height: calc(100vw * (25.33 / 375));
`;

const AchievememntProgressBarBlock = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`;

const AchievememntProgressBar = styled.div`
  position: relative;
  width: calc(100vw * (242 / 375));
  height: calc(100vw * (6 / 375));
  background: #e8e8e8;
  border-radius: calc(100vw * (22 / 375));
`;

const RunningIconBlock = styled.div`
  ${({ playAnimation }) =>
    playAnimation
      ? `@keyframes jump {

						0% { transform: translate(0%, 0%) scale(1, 1); }
						10% { transform: translate(0%, 0%) scale(1, 0.8); }
						20% { transform: translate(0%, -30%) scale(1, 0.9); } 
						30% { transform: translate(0%, -60%) scale(1, 1.1); }
						55% { transform: translate(0%, -70%) scale(1, 1); }
						65% { transform: translate(0%, -40%) scale(1, 1); }
						80% { transform: translate(0%, -10%) scale(1, 1); }
						
						100% { transform: translate(0%, 0%) scale(1, 1); }
					}
					animation: jump 0.3s steps(2);`
      : ""}

  position: absolute;
  top: calc(100vw * (-44.21 / 375));
  left: ${({ left }) =>
    left > 15 ? `calc(${left}% - 100vw * (48 / 375))` : 0};
  width: calc(100vw * (48 / 375));
  height: calc(100vw * (44.21 / 375));
  z-index: 10;
`;

const RunningIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const ProgressbarLine = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ width }) => width}%;
  height: 100%;
  background-color: #ffcf19;
  border-radius: calc(100vw * (22 / 375));
`;

const TaskCountBlock = styled.div`
  flex: 0 1 auto;
  display: flex;
  align-items: flex-end;
  height: calc(100vw * (30 / 375));
`;

const CompleteNum = styled.span`
  font-size: calc(100vw * (20 / 375));
  font-weight: 500;
  line-height: calc(100vw * (18.27 / 375));
  margin-right: calc(100vw * (2 / 375));
`;

const TotalTaskNum = styled.span`
  font-size: calc(100vw * (14 / 375));
  color: #7f7f7f;
`;

const GoalIconBlock = styled.span`
  position: absolute;
  bottom: calc(100vw * (0 / 375));
  right: calc(100vw * (55 / 375));
  width: calc(100vw * (28.53 / 375));
`;

const GoalIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const JumpBtn = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 26px;
  bottom: 40px;
  z-index: 300;
  border-radius: 100%;
  background-color: #ffc036;
  width: calc(100vw * (58 / 375));
  height: calc(100vw * (58 / 375));
  box-shadow: 0px 0px 20px #e0cd8d;
`;

const JumpBtnImgBlock = styled.div`
  position: relative;
  width: calc(100vw * (22.5 / 375));
  height: calc(100vw * (25 / 375));
`;

const JumpBtnImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
